module.exports = __webpack_public_path__ + "img/name.9e670cff.svg";